import { useEffect } from 'react';
import { useTranslation } from '@frontend/i18n';
import { JustifiTokenizePaymentMethod, useJustifiLoadedState } from '@frontend/payments-justifi-wrapper';
import { classNames } from '@frontend/string';
import { ContentLoader, TextField } from '@frontend/design-system';
import { UseAddCardOnFileJustifi } from '../../../../../../hooks/justifi/use-add-card-on-file-justifi';

export type AddCardFormProps = {
  className?: string;
  shouldShowLoading: boolean;
  nameFieldProps: UseAddCardOnFileJustifi['nameFieldProps'];
  justifiProps: UseAddCardOnFileJustifi['justifiProps'];
  elementRef: UseAddCardOnFileJustifi['elementRef'];
  resetFormState: UseAddCardOnFileJustifi['resetFormState'];
};
export const AddCardForm = ({
  className,
  shouldShowLoading,
  nameFieldProps,
  justifiProps,
  elementRef,
  resetFormState,
}: AddCardFormProps) => {
  const { t } = useTranslation('payments');

  const {
    paymentMethod: { isLoaded },
  } = useJustifiLoadedState(['paymentMethod']);

  useEffect(() => {
    return () => {
      resetFormState();
    };
  }, []);

  return (
    <div className={classNames('card-on-file', className)}>
      <ContentLoader show={shouldShowLoading || !isLoaded} />
      <TextField name='cardholderName' label={t('Cardholder Name')} hasNonFloatingLabel {...nameFieldProps} />
      <JustifiTokenizePaymentMethod elementRef={elementRef} {...justifiProps} />
    </div>
  );
};
